import React from 'react';
import { Glyphicon } from 'react-bootstrap';
import { func, string } from 'prop-types';
import style from './style';

const Tag = ({onRemove,text,...props}) => 
	<style.Tag {...props}>
		<style.RemoveButton onClick = {onRemove}>
			<Glyphicon glyph="remove"></Glyphicon>
		</style.RemoveButton>
		<style.MoveButton>
			{text}
		</style.MoveButton>
	</style.Tag>;

Tag.propTypes = {
	onRemove: func,
	text : string
};

const ReadOnlyTag = ({text,onClick,...props}) =>
	<style.ReadOnlyTag.Wrapper onClick={(e)=>{onClick&&onClick(text,e);}} {...props}>
		<Glyphicon glyph="tag"></Glyphicon>
		<style.ReadOnlyTag.TextWrapper>{text}</style.ReadOnlyTag.TextWrapper>
	</style.ReadOnlyTag.Wrapper>;

ReadOnlyTag.propTypes = {
	onClick: func,
	text : string
};

export {ReadOnlyTag};
export default Tag;